import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { PageCache, Pages } from "./types";

export type ApiState = {
  contentHash?: number;
  authorizationToken?: string;
  pagesCache: Map<Pages, PageCache>;
};

export const useApiStore = create<ApiState>()(
  persist(
    ({}) => ({
      contentHash: undefined,
      authorizationToken: undefined,
      pagesCache: new Map<Pages, PageCache>(),
    }),
    { name: "api-storage" }
  )
);
